/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_By_Title_Category_OrInputs */

const en_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by title, category, or tags...`)
};

const es_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca por título, categoría o etiquetas...`)
};

const fr_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher par titre, catégorie ou tags...`)
};

const de_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche nach Titel, Kategorie oder Tags...`)
};

const ja_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル、カテゴリ、タグで検索...`)
};

const zh_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按标题、类别或标签搜索...`)
};

const ar_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث بالعنوان، الفئة، أو العلامات...`)
};

const id_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari berdasarkan judul, kategori, atau tag...`)
};

const it_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca per titolo, categoria o tag...`)
};

const ru_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по названию, категории или тегам...`)
};

const pt_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquise por título, categoria ou tags...`)
};

const ko_search_by_title_category_or = /** @type {(inputs: Search_By_Title_Category_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제목, 카테고리 또는 태그로 검색...`)
};

/**
* | output |
* | --- |
* | "Search by title, category, or tags..." |
*
* @param {Search_By_Title_Category_OrInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_by_title_category_or = /** @type {((inputs?: Search_By_Title_Category_OrInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_By_Title_Category_OrInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_by_title_category_or(inputs)
	if (locale === "es") return es_search_by_title_category_or(inputs)
	if (locale === "fr") return fr_search_by_title_category_or(inputs)
	if (locale === "de") return de_search_by_title_category_or(inputs)
	if (locale === "ja") return ja_search_by_title_category_or(inputs)
	if (locale === "zh") return zh_search_by_title_category_or(inputs)
	if (locale === "ar") return ar_search_by_title_category_or(inputs)
	if (locale === "id") return id_search_by_title_category_or(inputs)
	if (locale === "it") return it_search_by_title_category_or(inputs)
	if (locale === "ru") return ru_search_by_title_category_or(inputs)
	if (locale === "pt") return pt_search_by_title_category_or(inputs)
	return ko_search_by_title_category_or(inputs)
});